import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable, map, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

import { CoachingFieldName } from '@app/pages/coaching/coaching.constant';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { NgxsActionName, WebApiRoute } from '@app/shared/constants';
import { WebApiService } from '@app/shared/services/web-api.service';
import { HttpMethodEnum, Status } from '@app/shared/enums';
import { Utilities } from '@app/shared/utils/utilities';
import { BasedComponent } from '@shared/components/based.component';

@Component({
  selector: 'app-coaching-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (coachingFieldName.attachment){
        <a href="javascript:void(0);" (click)="onClick()">
          {{displayText$ | async | translate}}
        </a>
      }
      @case (coachingFieldName.attachmentVisibletoDriver){
        @if(data[field]===true) {
        <mat-checkbox disabled [checked]="true"></mat-checkbox>
        }
      }
      @case (coachingFieldName.status){
        @if(data[field]===status.INACTIVE) {
        <mat-checkbox disabled [checked]="true"></mat-checkbox>
        }
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }
  `
})
export class CoachingDataGridCell extends BasedComponent {
  webApiService = inject(WebApiService);

  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  status = Status;
  coachingFieldName = CoachingFieldName;
  isProcessingSub = new BehaviorSubject(false);
  isProcessing$ = this.isProcessingSub.asObservable();
  displayText$: Observable<string>;

  @Select(AppDataState.taskExecuting(NgxsActionName.GET_COACHING_ATTACHMENT)) processing$: Observable<boolean>;

  constructor() { super(); }

  override ngOnInit() {
    super.ngOnInit();
    this.displayText$ = this.isProcessing$.pipe(map(p => p ? "ml_144035" : "ml_143965"));
  }

  onClick = () => {
    this.isProcessingSub.next(true);
    var id = this.data[CoachingFieldName.coaching_Id];
    var fileName = this.data[CoachingFieldName.attachment];

    this.webApiService.requestRawData(HttpMethodEnum.GET, true, `${WebApiRoute.COACHING}/${id}/attachment`, null, null, "arraybuffer")
      .pipe(map(res => Utilities.BinaryFileDownload(res, fileName)), takeUntil(this.destroy$))
      .subscribe(res => {
        this.isProcessingSub.next(false);
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.isProcessingSub.complete();
  }
}
